export enum EPaymentView {
    static = 'static',
    modal = 'modal',
}
